import React, { FC, memo } from 'react';
import { XAxis, CartesianGrid, Tooltip, Line, LineChart } from 'recharts';
import formatPriceNumber from 'utils/formatPrice';
import { LegendText } from 'components/Typography';
import { Props } from './types';
import {
  Wrapper,
  LegendRowContainer,
  NameContainer,
  ColoredDot,
} from './styles';

const MultipleAreaChart: FC<Props> = ({
  data,
  isMoney,
  hideAxisX = false,
  yAxisTooltipName,
  names,
  colors,
  hasLegend,
  ...props
}) => {
  return (
    <>
      <Wrapper {...props}>
        <LineChart width={500} height={300} data={data}>
          <XAxis dataKey="xAxis" tick={hideAxisX} />

          <CartesianGrid vertical={false} stroke="#EDEDEF" />

          {isMoney ? (
            <Tooltip
              formatter={(value) => [
                formatPriceNumber(`${value}`),
                yAxisTooltipName,
              ]}
            />
          ) : (
            <Tooltip formatter={(value) => [value, yAxisTooltipName]} />
          )}
          {colors.map((item, index) => (
            <Line type="monotone" dataKey={names[index]} stroke={item} />
          ))}
        </LineChart>
      </Wrapper>
      {hasLegend && (
        <LegendRowContainer>
          {colors.map((item, index: number) => (
            <LegendRowContainer key={names[index]}>
              <NameContainer>
                <ColoredDot color={item} />
                <LegendText>Value{index + 1}</LegendText>
              </NameContainer>
            </LegendRowContainer>
          ))}
        </LegendRowContainer>
      )}
    </>
  );
};

export default memo(MultipleAreaChart);
